import React from 'react'
import * as PropTypes from "prop-types"

// Import typefaces
import 'typeface-montserrat'
import 'typeface-merriweather'

import { rhythm } from '../utils/typography'

import Img from 'gatsby-image'

class Bio extends React.Component {
  render() {
    return (
      <div
        style={{
          display: 'flex',
          marginBottom: rhythm(2.5),
          alignItems: 'flex-start'
        }}
      >
        <Img
          resolutions={this.props.author.avatar.childImageSharp.resolutions}
          alt={this.props.author.id}
          fadeIn={false}
          style={{
            marginRight: rhythm(1 / 2),
            marginBottom: 0,
            verticalAlign: "top",
            width: 60,
            height: 60,
            flex: "none"
          }}
          imgStyle={{
            borderRadius: "100%"
          }}
        />
        <div>
          <p>
            Written by <strong>{this.props.author.id}</strong>.
          </p>
          <p style={{ color: "#888888" }}>
            {this.props.author.bio}
          </p>
        </div>
      </div>
    )
  }
}

export default Bio

export const blogPostBioFragment = graphql`
fragment BlogPostBio_item on MarkdownRemark {
  frontmatter {
    author {
      id
      bio
      avatar {
        childImageSharp {
          resolutions(
            width: 60
            height: 60
            quality: 80
            traceSVG: {
              turdSize: 10
              background: "#f6f2f8"
              color: "#e0d6eb"
            }
          ) {
            ...GatsbyImageSharpResolutions_tracedSVG
          }
        }
      }
    }
  }
}
`



// WEBPACK FOOTER //
// ./src/components/Bio.js